import type { DonationSettings } from "./donationSettings"

import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const partialUpdateDonationSettings = async (
  params: Partial<DonationSettings>
) => {
  const { body } = await api.patch<DonationSettings>(
    "/donation-settings/",
    { body: params }
  )
  queryClient.setQueryData(
    [BASE_DONATION_SETTINGS_QUERY_KEY],
    body
  )
  return body
}
